(function () {
  function iniciarCabecera(contenedor) {
    var descripcion = contenedor.querySelector('[data-descripcion]');
    var boton = contenedor.querySelector('[data-ver-mas]');
    if (!descripcion || !boton || descripcion.dataset.iniciado === 'true') return;
    descripcion.dataset.iniciado = 'true';

    var abrir = boton.querySelector('[data-texto-abrir]');
    var cerrar = boton.querySelector('[data-texto-cerrar]');

    descripcion.classList.add('cabecera__descripcion--plegada');

    var desbordado = descripcion.scrollHeight > descripcion.clientHeight + 2;
    if (!desbordado) {
      descripcion.classList.remove('cabecera__descripcion--plegada');
      return;
    }

    boton.hidden = false;
    boton.setAttribute('aria-expanded', 'false');

    boton.addEventListener('click', function () {
      var plegada = descripcion.classList.toggle('cabecera__descripcion--plegada');
      boton.setAttribute('aria-expanded', plegada ? 'false' : 'true');
      if (abrir) abrir.hidden = !plegada;
      if (cerrar) cerrar.hidden = plegada;
    });
  }

  function iniciarTodo() {
    document.querySelectorAll('[data-cabecera]').forEach(iniciarCabecera);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciarTodo);
  } else {
    iniciarTodo();
  }

  document.addEventListener('shopify:section:load', iniciarTodo);
})();